<template>
  <div class="through-way">
    <el-tabs v-model="activeName" class="findWay">
      <el-tab-pane label="登录密码" name="pass">
        <div style="width:340px;margin:0 auto;" class="change-loginPass">
          <el-form :model="passChange" ref="passChange" :rules="passRules" label-width="0px" class="passChange">
            <el-form-item prop="oldPass">
              <el-input v-model="passChange.oldPass" placeholder="请输入旧密码" type="password" auto-complete="new-password"></el-input>
            </el-form-item>
            <el-form-item prop="newPass">
              <el-input v-model="passChange.newPass" placeholder="请输入新密码" type="password" auto-complete="new-password"></el-input>
            </el-form-item>
            <el-form-item prop="confirmPass">
              <el-input v-model="passChange.confirmPass" placeholder="确认新密码" type="password" auto-complete="new-password"></el-input>
            </el-form-item>
            <div style="text-align:center;">
              <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" @click="changeSuccess">完成</el-button>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="手机验证" name="phone">
        <div style="width:550px;margin:0 auto;" class="change-loginPass">
          <el-form :model="throughPhone" ref="throughPhone" :rules="phoneRules" label-width="100px" class="throughPhone">
            <el-form-item label="手机号" prop="newPhone">
              <p style="margin:0;font-size:16px;color:#333333;">{{userInfo.mobile? userInfo.mobile.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2"): ''}}</p>
            </el-form-item>
            <el-form-item label="验证码" prop="phoneVertifyCode" class="code">
              <el-input v-model="throughPhone.phoneVertifyCode" placeholder="请输入短信验证码" style="width:250px;"></el-input>
              <el-button type="primary" @click="getSmsRecords">{{getSms_button}}</el-button>
            </el-form-item>
            <div style="text-align:center;">
              <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" @click="findTroughPhone">确定</el-button>
              <p style="color:#999999">如果无法自己找回，请联系培训中心管理员。</p>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="密保验证" name="question">
        <div style="width:400px;margin:0 auto;" class="change-loginPass">
          <el-form :model="throughAnswer" ref="throughAnswer" :rules="questionRules" label-width="100px" class="throughAnswer">
            <el-form-item label="问题">
              <p style="margin:0;font-size:16px;color:#333333;">{{userInfo.question ? userInfo.question : ''}}</p>
            </el-form-item>
            <el-form-item label="答案" prop="answer" class="code">
              <el-input v-model="throughAnswer.answer" placeholder="请输入答案" style="width:250px;"></el-input>
            </el-form-item>
            <div style="text-align:center;">
              <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" @click="findTroughAnwser">确定</el-button>
              <p style="color:#999999">如果无法自己找回，请联系培训中心管理员。</p>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="邮箱验证" name="email">
        <div style="width:550px;margin:0 auto;" class="change-loginPass">
          <el-form :model="throughEmail" ref="throughEmail" :rules="emailRules" label-width="100px" class="throughEmail">
            <el-form-item label="邮箱">
              <p style="margin:0;font-size:16px;color:#333333;">{{userInfo.emailAddress}}</p>
            </el-form-item>
            <el-form-item label="验证码" prop="emailVertifyCode" class="code">
              <el-input v-model="throughEmail.emailVertifyCode" style="width:250px;" placeholder="请输入邮件验证码"></el-input>
              <el-button type="primary" @click="getEmailSms">{{email_button}}</el-button>
            </el-form-item>
            <div style="text-align:center;">
              <el-button type="primary" style="width:100px;background:#1060ab;font-size:16px;margin-top:33px;" @click="findTroughEmail">确定</el-button>
              <p style="color:#999999">如果无法自己找回，请联系培训中心管理员。</p>
            </div>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data () {
    const checkNewPhone = (rule, value, callback) => {
      if (/^((12|13|14|15|17|18|19)[0-9]{1}\d{8})$/.test(value)) {
        callback()
      } else {
        callback(new Error('手机格式错误'))
      }
    }
    const newSmsCheck = (rule, value, callback) => {
      this.$ajax
        .post(
          '/compute-oper-service/SmsRecords/isCheckCode',
          this.postData({
            checkCode: this.throughPhone.phoneVertifyCode,
            mobile: this.userInfo.mobile
          })
        )
        .then(res => {
          if (res.data === 0) {
            callback()
          } else {
            callback(new Error('验证码错误'))
          }
        })
    }
    const checkEmail = (rule, value, callback) => {
      var myReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/
      if (value.length > 30) {
        callback(new Error('邮箱长度过长'))
      } else if (myReg.test(value)) {
        callback()
      } else {
        callback(new Error('邮箱格式不正确'))
      }
    }
    const newEmailSms = (rule, value, callback) => {
      this.$ajax
        .post(
          '/compute-oper-service/SmsRecords/checkEmailCode',
          this.postData({
            checkCode: this.throughEmail.emailVertifyCode,
            userId: this.userInfo.id
          })
        )
        .then(res => {
          if (res.data === 0) {
            callback()
          } else {
            callback(new Error('验证码错误'))
          }
        })
    }
    const oldPasswordCheck = (rule, value, callback) => {
      this.$ajax
        .post(
          '/comuser-service/Account/findUpdatePassword',
          this.postData({
            id: sessionStorage.userUuid,
            usedPassword: this.passChange.oldPass
          })
        )
        .then(res => {
          if (res.code === '-10') {
            callback(new Error(res.message))
          } else {
            callback()
          }
        })
    }
    const pwCheck = (rule, value, callback) => {
      if (!this.passChange.newPass) {
        callback(new Error('请输入新密码'))
      } else if (this.passChange.oldPass === this.passChange.newPass) {
        callback(new Error('新旧密码不能重复'))
      } else if (
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(
          this.passChange.newPass
        )
      ) {
        callback(new Error('请输入8-16位，数字和字母的组合'))
      } else {
        callback()
      }
    }
    const rePwCheck = (rule, value, callback) => {
      if (
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(
          this.passChange.newPass
        )
      ) {
        callback(new Error('密码格式错误'))
      } else if (
        this.passChange.newPass !== this.passChange.confirmPass
      ) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      userInfo: {},
      time: 0,
      time2: 0,
      activeName: 'phone',
      getSms_button: '发送验证码',
      email_button: '发送邮件进行验证',
      throughPhone: {
        phoneVertifyCode: ''
      },
      throughAnswer: {
        answer: ''
      },
      throughEmail: {
        emailVertifyCode: ''
      },
      phoneRules: {
        phoneVertifyCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
          { validator: newSmsCheck, trigger: 'submit' }
        ]
      },
      questionRules: {
        answer: {required: true, message: '请输入答案', trigger: 'blur'}
      },
      emailRules: {
        emailVertifyCode: [
          { required: true, message: '请输入邮箱验证码', trigger: 'blur' },
          { validator: newEmailSms, trigger: 'submit' }
        ]
      },
      passRules: {
        oldPass: [
          {required: true, message: '请输入旧密码', trigger: 'blur'},
          { validator: oldPasswordCheck, trigger: 'blur' }
        ],
        newPass: [
          // {required: true, message: '请输入密码', trigger: 'blur'},
          { required: true, validator: pwCheck, trigger: 'blur' }
        ],
        confirmPass: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: rePwCheck, trigger: 'blur' }
        ]
      },
      questionList: [],
      changeMethod: '',
      whichWay: '',
      passChange: {
        oldPass: '',
        newPass: '',
        confirmPass: ''
      }
    }
  },
  created () {
    // if (sessionStorage.step !== 'idChecked') {
    //   this.$router.push('/')
    // } else {
    this.changeMethod = this.$route.params.way
    if (this.changeMethod === 'email') {
      this.whichWay = '/trainClass/personalCenter/accountInfo/setEma'
      this.activeName = 'email'
    } else if (this.changeMethod === 'phone') {
      this.whichWay = '/trainClass/personalCenter/accountInfo/setPho'
      this.activeName = 'phone'
    } else if (this.changeMethod === 'question') {
      this.whichWay = '/trainClass/personalCenter/accountInfo/setQue'
      this.activeName = 'question'
    } else if (this.changeMethod === 'pass') {
      this.whichWay = '/trainClass/personalCenter/accountInfo/setPa'
      this.activeName = 'pass'
    }
    this.getUserInfo()
    // }
  },
  mounted () {
  },
  methods: {
    getUserInfo () {
      this.$ajax
        .post(
          '/comuser-service/Account/getUserInfoByName',
          this.postData({
            loginName: sessionStorage.account
          })
        )
        .then(res => {
          if (res.code === '200') {
            this.userInfo = res.data
            sessionStorage.userId = res.data.id
          }
        })
    },
    findTroughPhone () {
      this.$refs['throughPhone'].validate(valid => {
        if (valid) {
          this.$message({
            message: '验证成功',
            type: 'success'
          })
          setTimeout(() => {
            sessionStorage.step = 'infoChecked'
            sessionStorage.whichWay = this.changeMethod
            this.$router.push(this.whichWay)
          }, 1000)
        } else {
          this.$message.error('验证失败')
        }
      })
    },
    findTroughAnwser () {
      this.$refs['throughAnswer'].validate(valid => {
        if (valid) {
          this.$ajax
            .post(
              '/comuser-service/Account/checkUserInfo',
              this.postData({
                id: this.userInfo.id,
                question: this.userInfo.question,
                answer: this.throughAnswer.answer
              })
            )
            .then(res => {
              if ((res.data === 0)) {
                this.$message({
                  message: '验证成功',
                  type: 'success'
                })
                setTimeout(() => {
                  sessionStorage.step = 'infoChecked'
                  sessionStorage.whichWay = this.changeMethod
                  this.$router.push(this.whichWay)
                }, 1000)
              } else {
                this.$message.error('密保答案错误')
              }
            })
        }
      })
    },
    findTroughEmail () {
      this.$refs['throughEmail'].validate(valid => {
        if (valid) {
          this.$message({
            message: '验证成功',
            type: 'success'
          })
          setTimeout(() => {
            sessionStorage.step = 'infoChecked'
            sessionStorage.whichWay = this.changeMethod
            this.$router.push(this.whichWay)
          }, 1000)
        } else {
          this.$message.error('验证失败')
        }
      })
    },
    getSmsRecords () {
      if (this.time === 0) {
        this.time = 60
        this.timer()
        this.$ajax
          .post(
            '/compute-oper-service/SmsRecords/addCheckCodexbkgj',
            this.postData({
              codeType: 1,
              phoneNumber: this.userInfo.mobile
            })
          )
          .then(res => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '验证码发送成功'
              })
            } else {
              this.$message.error(res.message)
            }
          })
      }
    },
    timer () {
      if (this.time > 0) {
        this.time--
        this.getSms_button = this.time + 's后重新获取'
        var timer = setTimeout(this.timer, 1000)
      } else if (this.time === 0) {
        this.getSms_button = '获取短信验证码'
        clearTimeout(timer)
      }
    },
    next () {
      this.$router.push('/FindPass/ChangePassword')
    },
    // contactAdmin () {
    //   this.$router.push('/FindPass/ContactAdmin')
    // },
    getEmailSms () {
      if (this.time2 === 0) {
        this.time2 = 60
        this.timer2()
        this.$ajax
          .post(
            '/compute-oper-service/SmsRecords/sendEmail',
            this.postData({
              userId: this.userInfo.id,
              type: '1',
              email: this.userInfo.emailAddress
            })
          )
          .then(res => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '验证码发送成功'
              })
            } else {
              this.$message.error('验证码发送失败')
            }
          })
      }
    },
    timer2 () {
      if (this.time2 > 0) {
        this.time2--
        this.email_button = this.time2 + 's后重新获取'
        var timer = setTimeout(this.timer2, 1000)
      } else if (this.time2 === 0) {
        this.email_button = '获取验证码'
        clearTimeout(timer)
      }
    },
    changeSuccess () {
      this.$refs['passChange'].validate(valid => {
        if (valid) {
          this.$ajax
            .post(
              '/comuser-service/Account/updatesPasswordByPassWord',
              this.postData({
                id: sessionStorage.userUuid,
                newPassword: this.passChange.newPass
              })
            )
            .then(res => {
              if ((res.code === '200')) {
                debugger
                this.$message({
                  message: '密码修改成功',
                  type: 'success'
                })
                setTimeout(() => {
                  sessionStorage.hasChecked = 'changePass'
                  this.$router.push('/trainClass/personalCenter/accountInfo/accountSafty')
                }, 1000)
              } else {
                this.$message.error(res.message)
              }
            })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.through-way {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .el-tab-pane {
    margin-top:120px;
  }
  .findWay {
    margin: 40px 40px 0px 40px;
    .el-tabs__item {
      font-size:20px;
      color:#999999;
      height: 50px;
    }
    .el-tabs__nav-wrap{
      height: 50px;
    }
    .el-tabs__active-bar{
      width: 120px!important;
      background-color: #333333;
    }
    .el-tabs__item:hover{
      color: #333333;
    }
    .el-tabs__item.is-active {
      color: #333333;
    }
  }
  .throughPhone {
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 400px;
    }
    .code {
        .el-button--primary {
          background-color: #eeeeee;
          border-color: #d2d2d2;
          color: #666666;
          margin-left: 10px;
        }
      }
  }
  .throughAnwser {
    margin-bottom:33px;
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 400px;
    }
  }
  .throughEmail {
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 400px;
    }
    .code {
        .el-button--primary {
          background-color: #eeeeee;
          border-color: #d2d2d2;
          color: #666666;
          margin-left: 10px;
        }
      }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/accountInfo/throughWay.vue